import { LuBadgeCheck, LuHandshake, LuPencilRuler } from "react-icons/lu";
import { Section, Container, SectionEyebrow, SectionTitle } from "../ui/Section";
import { MotionItem, fadeUp, fadeUpSmall, scaleIn } from "../ui/Motion";
import {
  Header,
  Grid,
  PillarCard,
  IconWrap,
  PillarTitle,
  PillarDesc,
  PillarLink,
} from "./styles/ServicePillars.styles";

const PILLARS = [
  {
    icon: LuBadgeCheck,
    title: "Authorized Princess Dealer",
    description:
      "The full Princess Yachts range, available factory-direct with the support and warranty of an authorized representative.",
    linkLabel: "View New Yachts",
    linkTo: "/yachts?condition=availableNow",
    accent: "primary",
  },
  {
    icon: LuHandshake,
    title: "Curated Brokerage",
    description:
      "Distinguished pre-owned vessels, vetted by our team and offered through a transparent brokerage process.",
    linkLabel: "Explore Brokerage",
    linkTo: "/yachts?condition=brokerage",
    accent: "primary",
  },
  {
    icon: LuPencilRuler,
    title: "New Buildings",
    description:
      "Yacht building management, commissioned to your specification and supervised from first sketch to delivery.",
    linkLabel: "Discover New Builds",
    linkTo: "/new-buildings",
    accent: "gold",
  },
];

function ServicePillars() {
  return (
    <Section $bg="offWhite">
      <Container>
        <Header>
          <MotionItem $variants={fadeUpSmall}>
            <SectionEyebrow>What We Offer</SectionEyebrow>
          </MotionItem>
          <MotionItem $variants={fadeUp}>
            <SectionTitle>Three Paths to Ownership</SectionTitle>
          </MotionItem>
        </Header>

        <Grid slow>
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <PillarCard
                key={p.title}
                $variants={scaleIn}
                $accent={p.accent}
              >
                <IconWrap $accent={p.accent}>
                  <Icon />
                </IconWrap>
                <PillarTitle>{p.title}</PillarTitle>
                <PillarDesc>{p.description}</PillarDesc>
                <PillarLink to={p.linkTo}>{p.linkLabel}</PillarLink>
              </PillarCard>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
}

export default ServicePillars;
